module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isAddValid),
      callback: function($$v) {
        _vm.isAddValid = $$v
      },
      expression: "isAddValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('center', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.departmentLoader == true) ? _c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding": "12px"
    },
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "screenTip"
  }, [_c('span', [_c('i', {
    staticClass: "material-icons infoIcon",
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("information")]), _vm._v(" This link is to test creating a service form either\n            as a customer or a Builders rep for a specific store.\n                  ")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Store:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.branchList,
      "item-value": "code",
      "item-text": "name",
      "label": "Store",
      "autocomplete": "",
      "solo": ""
    },
    model: {
      value: (_vm.store),
      callback: function($$v) {
        _vm.store = $$v
      },
      expression: "store"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer Name and Surname:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Customer Name and Surname",
      "single-line": "",
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.customerName),
      callback: function($$v) {
        _vm.customerName = $$v
      },
      expression: "customerName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer Email:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Customer Email",
      "single-line": "",
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.customerEmail),
      callback: function($$v) {
        _vm.customerEmail = $$v
      },
      expression: "customerEmail"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "smallDescription"
  }, [_vm._v("Ensure the email address is in the Builders\n                  Public user tree")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer Contact:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Customer Contact",
      "single-line": "",
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.customerContact),
      callback: function($$v) {
        _vm.customerContact = $$v
      },
      expression: "customerContact"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Agent Email:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Agent Email",
      "single-line": "",
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.agentEmail),
      callback: function($$v) {
        _vm.agentEmail = $$v
      },
      expression: "agentEmail"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "smallDescription"
  }, [_vm._v("Leave this blank if you are testing a customer form"), _c('br'), _vm._v("Ensure the email address is in the Builders\n                 Rep user tree")])], 1), _vm._v(" "), (_vm.generatedLink != '') ? _c('v-flex', {
    staticStyle: {
      "padding": "30px !important",
      "text-align": "center",
      "background": "#efefef"
    },
    attrs: {
      "lg12": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "12px !important"
    }
  }, [_vm._v(_vm._s(_vm.generatedLink))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncGenerateLink()
      }
    }
  }, [_vm._v("Generate Link")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}